export const APP_STORE_URL = "https://apps.apple.com/dk/app/mysabbat/id6758349030?l=da";
